// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"b9702a3a","36":"2ed9cbc9","651":"f013bc2a","686":"227e2e0c","794":"4cb1a317","858":"484b176d"}[chunkId] + ".chunk.js";
};